import React from "react";

const Mail = ({ color = "var(--heading-color)", size = "20" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.1665 3.08301L5.92937 6.41702C6.31506 6.68699 6.5079 6.82198 6.71766 6.87427C6.90294 6.92046 7.09673 6.92046 7.28202 6.87427C7.49178 6.82198 7.68462 6.687 8.0703 6.41702L12.8332 3.08301M3.9665 10.6663H10.0332C11.0133 10.6663 11.5033 10.6663 11.8777 10.4756C12.2069 10.3078 12.4747 10.0401 12.6424 9.71083C12.8332 9.33648 12.8332 8.84643 12.8332 7.86634V4.13301C12.8332 3.15292 12.8332 2.66287 12.6424 2.28852C12.4747 1.95924 12.2069 1.69152 11.8777 1.52375C11.5033 1.33301 11.0133 1.33301 10.0332 1.33301H3.9665C2.98641 1.33301 2.49637 1.33301 2.12202 1.52375C1.79274 1.69152 1.52502 1.95924 1.35724 2.28852C1.1665 2.66287 1.1665 3.15292 1.1665 4.13301V7.86634C1.1665 8.84643 1.1665 9.33648 1.35724 9.71083C1.52502 10.0401 1.79274 10.3078 2.12202 10.4756C2.49637 10.6663 2.98641 10.6663 3.9665 10.6663Z"
        stroke="#6B7280"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Mail;
